module.exports = __webpack_public_path__ + "img/gyuszigumi2.aa64e1f6.jpg";